import { Field } from 'formik';
import { Label } from '../components/Label/Label';
import { Select, OptionProps } from '../components/Select/Select';
import { validateField } from './validations';
import { FormItemError } from '../components/FormItemError/FormItemError';

export const renderSelectField = (
  name: string,
  options: OptionProps[],
  label?: string | [string, string],
  className?: string,
  placeholder?: string,
  max?: number,
  error?: string,
  optional?: boolean,
  onHelpClick?: () => void,
  allowFieldValidation?: boolean
) => {
  const renderLabel = (label: string | [string, string], id: string) => {
    if (Array.isArray(label)) {
      return (
        <Label htmlFor={id} description={label[1]}>
          {label[0]}
        </Label>
      );
    } else {
      return (
        <Label htmlFor={id} onHelpClick={onHelpClick}>
          {label}
        </Label>
      );
    }
  };

  return (
    <div key={name}>
      {label && renderLabel(label, name)}
      <Field
        name={name}
        id={name}
        component={Select}
        className={className}
        options={options}
        placeholder={placeholder}
        error={!!error}
        validate={(value: string | number) =>
          (allowFieldValidation ?? true) &&
          validateField(value, optional, undefined, max, 'select')
        }
      />
    </div>
  );
};
